type Connection<T> = {
    readonly edges: readonly ({ node: T | null } | null)[] | null;
} | null;

export const flattenConnectionNodes = <T>(connection?: Connection<T>): T[] => {
    const edges = connection?.edges || [];
    return edges.reduce<T[]>((acc, edge) => (edge?.node ? acc.concat(edge.node) : acc), []);
};
